export const environment={
	siteUrl:'https://www-test.lyomedical.com.co',
	production:false,
	google:{
		recaptcha3SiteKey:'6LdhKBUsAAAAAMlAawEJb3ytm-_9rZVfpdM9mQph'
	},
	facebook:{
		// TODO: replace with the real Facebook app id and Meta Pixel id
		appId:'000000000000000',
		pixelId:'000000000000000'
	},
	x:{
		// TODO: replace with the real X Pixel id before enabling marketing consent
		pixelId:'oabcd'
	},
	// TODO: fill in before publishing the legal pages
	legal:{
		companyName:'<RAZON SOCIAL>',
		tradeName:'L&O Medical',
		taxId:'<NIT>',
		address:'<DIRECCION>',
		city:'<CIUDAD>',
		country:'Colombia',
		email:'<CORREO DE CONTACTO>',
		effectiveDate:'2026-09-14'
	},
	firebase:{
		'apiKey':'AIzaSyBvus758DZtE1rCMZ1XHnlg26LolB0Qebg',
		'appId':'1:844479255488:web:3194954d53f6125a31ee25',
		'authDomain':'lyomedical-test2.firebaseapp.com',
		'databaseURL':'',
		'measurementId':'G-X280CH8N76',
		'messagingSenderId':'844479255488',
		'projectId':'lyomedical-test2',
		'storageBucket':'lyomedical-test2.firebasestorage.app'
	},
	functions:{
		contact:'https://function-contact-test.lyomedical.com.co/contact'
	},
	contact:{
		instagram:'https://instagram.com/lyomedical',
		bogota:{
			phone:'+573135759999',
			mapUrl:'https://maps.app.goo.gl/qSsH9uonRPadvfpR6',
			embedUrl:'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26434.155945005346!2d-74.09193990341016!3d4.620425100467241!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9986afa4c64f%3A0xe1c8fb420621a2de!2sConsultorio%20m%C3%A9dico%20familiar!5e0!3m2!1sen!2sco!4v1675430496591!5m2!1sen!2sco',
			city:'Bogota',
			country:'Colombia',
			line1:'Cra. 15 #33-50',
			line2:'consultorio 222',
			open_hours:'10:00 am - 8:00 pm',
			open_hours_holiday:'12:00 pm - 6:00 pm'
		},
		ibague:{
			phone:'+573004639184',
			mapUrl:'https://maps.app.goo.gl/7NwWbUiACQdLYiAK9',
			embedUrl:'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3977.883102160159!2d-75.2077519!3d4.4328657!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e38c548b37c29bf%3A0xa01f059064ab2f89!2sEDIFICIO%20PIEDRAPINTADA%20X!5e0!3m2!1sen!2sco!4v1674999579071!5m2!1sen!2sco',
			city:'Ibague',
			country:'Colombia',
			line1:'Cl. 49a #4b-20',
			line2:'consultorio 333',
			open_hours:'10:00 am - 8:00 pm',
			open_hours_holiday:'12:00 pm - 6:00 pm'
		}
	}
};
